import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './lib/auth';
import { bootBanner, installGlobalErrorLogging } from './lib/debug';
import { initPwa } from './lib/pwa';
import './styles.css';

installGlobalErrorLogging();
initPwa();

bootBanner({
  'built at': new Date().toISOString(),
  host: window.location.host,
  'user agent': navigator.userAgent,
  href: window.location.href,
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
